import { render } from "./ChangePwdPage.vue?vue&type=template&id=717c0836"
import script from "./ChangePwdPage.vue?vue&type=script&lang=js"
export * from "./ChangePwdPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__